@if (isLoadingLabelVisible) {
  <div class="modal">
    <div class="modal-dialog-content">
      <p>{{loadingMessage}}</p>
    </div>
  </div>
}

@if (launchedAsSubcomponent === false) {
  <div id="tooltippopup">
    <p >
      {{tutorialTooltipMessage}}
    </p>
    <div id="arrow" data-popper-arrow></div>
  </div>
}
  <div [ngStyle]="{'background-color': (isCompleted) ? '#eee': 'white', 'color': (isCompleted) ? '#888': 'black'}" class="m-0 p-0" [ngStyle]="{
    'border-right': type === 'post' && post.color !== '#ffffff' ? '8px solid ' + post.color : 'none',
    'border-left': type === 'workpackage' && post.color !== '#ffffff' ? '8px solid ' + post.color : 'none'}">
            @if (userId != undefined && userId != '') {
              <app-inlinetutorial [title]="'Here you can see task of content details.'" [body]="'Content consists of sections. There are multiple section types, such as formatted text, links, images, files, calendar alerts, tables, and more. You can add a new section by clicking on the icon to the left of a section or by typing / within the section.'" [key]="'contentdetails'" [userId]="userId"></app-inlinetutorial>
            }
    <div class="m-0 p-0" style="max-width: 100%;">
      <div class="m-0 p-0">
        <div class="position-menu w-100 px-3">
          <div class="btn-group rightcorner" role="group" >
            @if (type =='workpackage') {
              <button class="btn btn-sm btn-outline-secondary dropdown-toggle btn-light my-btn" style="max-width: 120px;" type="button" data-bs-toggle="dropdown">
                {{statusName}}
              </button>
            }
            @if (type ==='workpackage') {
              <ul class="dropdown-menu">
                @for (c of columns; track c.key; let colIndex = $index) {
                  <li>
                    <a class="dropdown-item small" (click)="updateStatus(colIndex)">
                      {{c.name}}
                    </a>
                  </li>
                }
              </ul>
            }
            @if (fields.length === 0) {
              <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Add the first field" data-bs-delay="{show: 1000}" class="btn btn-sm btn-outline-secondary" (click)="addField(0, 'label')">
                <i class="bi bi-plus"></i>
                Add field
              </button>
            }
            @if (isReadOnly === false && isPostUpdated === true) {
              <button id="save" type="button" class="btn btn-sm btn-outline-secondary my-btn" (click)="save()" data-bs-toggle="tooltip" data-bs-placement="top" title="Save content" data-bs-delay="{show: 1000}">
                <span class="material-symbols--save-outline"></span>
              </button>
            }
            @if (launchedAsSubcomponent == false && launchedAsDialog == true) {
              <button id="close" type="button" class="btn btn-sm btn-outline-secondary my-btn" (click)="close(false)" data-bs-toggle="tooltip" data-bs-placement="top" title="Close window without saving" data-bs-delay="{show: 1000}">
                <span class="mdi--close"></span>
              </button>
            }
            @if (templateKey == 'link') {
              <button type="button" class="btn btn-sm btn-outline-secondary my-btn" (click)="scrapePage(pastedLink, currentFieldIndex)" data-bs-toggle="tooltip" data-bs-placement="top" title="Generate summary of pasted link page" data-bs-delay="{show: 1000}">
                <span class="mdi--alien-outline"></span>
                Summarize link
              </button>
            }
            @if (templateKey == 'image' && lastImageURL != '') {
              <button type="button" class="btn btn-sm btn-outline-secondary my-btn" (click)="getImageDescription(lastImageURL)" data-bs-toggle="tooltip" data-bs-placement="top" title="Generate image description" data-bs-delay="{show: 1000}">
                <span class="mdi--alien-outline"></span>
                Describe image
              </button>
            }
            @if (editModeSelected === false && isReadOnly == false && bookMode === false) {
              <button type="button" (click)="switchViewMode()" class="btn btn-sm btn-outline-secondary btn-sm my-btn" data-bs-toggle="tooltip" data-bs-placement="top" title="Switch to edit mode" data-bs-delay="{show: 1000}">
                <span class="mdi--pencil-off-outline"></span>
              </button>
            }
            @if (editModeSelected === true && isReadOnly == false && bookMode === false) {
              <button type="button" (click)="switchViewMode()" class="btn btn-sm btn-outline-secondary btn-sm my-btn" data-bs-toggle="tooltip" data-bs-placement="top" title="Switch to view mode" data-bs-delay="{show: 1000}">
                <span class="mdi--pencil-outline"></span>
              </button>
            }
            <button type="button" (click)="copyLink()" class="btn btn-sm btn-outline-secondary btn-sm my-btn" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy link to this page" data-bs-delay="{show: 1000}">
              <span class="material-symbols--link"></span>
            </button>
            <button type="button" data-bs-toggle="dropdown" class="btn btn-sm btn-outline-secondary btn-sm dropdown-toggle my-btn">
              <i class="bi bi-list"></i>
            </button>
            <!--button type="button" class="btn btn-sm btn-outline-secondary" (click)="changeEmbeddingModel()">
            {{embeddingModel}}
          </button-->
          <ul class="dropdown-menu no-break min-width">
            @if (isChatVisible == false) {
              <li>
                <a (click)="showChat()" type="button" class="btn btn-outline-secondary btn-sm noborder" >
                  <i class="bi bi-chat-left-text"></i>
                  Show discussion
                </a>
              </li>
            }
            @if (isChatVisible == true) {
              <li>
                <a (click)="hideChat()" type="button" class="btn btn-outline-secondary btn-sm noborder" >
                  <i class="bi bi-chat-left-text"></i>
                  Hide discussion
                </a>
              </li>
            }
            <li>
              <a (click)="showAIAssistant(0)" type="button" class="btn btn-outline-secondary btn-sm noborder" >
                <i class="mdi--alien-outline"></i>
                AI Assistant
              </a>
            </li>
            <li>  
              <a (click)="setColorClicked()" type="button" class="btn btn-outline-secondary btn-sm noborder">
                <i class="bi bi-palette" [ngStyle]="{'color': color}"></i>
              Change color
            </a>
            </li>
              @if (type == 'workpackage' && isReadOnly == false) {
                <li>
                  <a (click)="addAcceptanceCriteria()" type="button" class="btn btn-outline-secondary btn-sm noborder" >
                    <i class="mdi--alien-outline"></i>
                    Add acceptance criteria
                  </a>
                </li>
                <li>  
                  <a (click)="showPeopleSearchPopup()" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-person-plus"></i>
                  Add people to task
                </a>
                </li>
                <li>  
                  @if (areKidsColored) {
                  <a (click)="setColorKids()" type="button"  class="btn btn-outline-secondary btn-sm noborder">
                  <i class="bi bi-check-square"></i>
                  Color subtasks
                </a>
                } @else {
                  <a (click)="setColorKids()" type="button"  class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-square"></i>
                    Don't color subtasks
                  </a>
                }
                </li>
                <li>  
                  <a (click)="showTimeTrackerPopup()" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-clock"></i>
                    Report effort and dates
                  </a>
                </li>

            <li>
              @if (isCompleted == true) {
                <a (click)="completeWorkpackage(false)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                  <i class="bi bi-circle"></i>
                  Check as completed
                </a>
              } @else {
                <a (click)="completeWorkpackage(true)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                  <i class="bi bi-check-circle"></i>
                  Check as uncompleted
                </a>
              }
            </li>
              }
            @if (type =='post') {
              <li>
                @if (isFavourite == false && type == 'post') {
                  <a (click)="setFavourite(true)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-heart"></i>
                    Add to favourite
                  </a>
                } @else {
                  <a (click)="setFavourite(false)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-heartbreak"></i>
                    Remove from favourite
                  </a>
                }
              </li>
              <li>
                @if (isTop == false) {
                  <a (click)="pinToTop(true)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-chevron-double-up"></i>
                    Pin to top
                  </a>
                } @else {
                  <a (click)="pinToTop(false)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-chevron-double-down"></i>
                    Unpin from top
                  </a>
                }
              </li>
              <li>
                @if (isRead == false) {
                  <a (click)="readContent(true)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-circle"></i>
                    Check as read
                  </a>
                } @else {
                  <a (click)="readContent(false)" type="button" class="btn btn-outline-secondary btn-sm noborder">
                    <i class="bi bi-check-circle"></i>
                    Check as not read
                  </a>
                }
              </li>
            }
            <li>
              @if ((isNewPost == false && isReadOnly == false) && editModeSelected == true) {
                <a (click)="remove()" type="button" class="btn btn-outline-secondary btn-sm noborder">
                  <i class="bi bi-trash3"></i>
                  Delete
                </a>
              }
            </li>
            <li>
              @if (isReadOnly == false && editModeSelected == true) {
                <a (click)="showTemplatePopup()" type="button" class="btn btn-outline-secondary btn-sm noborder">
                  <i class="bi bi-clipboard-plus"></i>
                  Save as template
                </a>
              }
            </li>
            <li>
              @if (type == 'workpackage' && isReadOnly == false) {
                <a (click)="copyToKnowledgeBase()" type="button" class="btn btn-outline-secondary btn-sm noborder">
                  <i class="bi bi-journal-plus"></i>
                  Clone to knowledge base
                </a>
              }
            </li>
            <!--li>
            <a (click)="copyToKanban()" *ngIf="type == 'post'" type="button" class="btn btn-outline-secondary btn-sm noborder">
              <i class="bi bi-window-plus"></i>
              Copy as task
            </a>
          </li-->
        </ul>
      </div>
        </div>
        <!-- add template popup -->
        @if (showAddTemplatePopup == true && isReadOnly == false) {
          <div class="position-absolute rightcorner popup">
            <form class="px-3 py-2">
              <div class="mb-3">
                <label for="inputTextField" class="form-label">Type name of new content template</label>
                <input type="text" class="form-control" id="inputTextField" [(ngModel)]="addTemplateName" name="inputText">
              </div>
              <div class="btn-group" role="group" >
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="saveNewTemplate()">Save</button>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeAddTemplatePopup()">Close</button>
              </div>
            </form>
          </div>
        }
      
        @if (showSearchwModal && isReadOnly == false) {
          <app-peoplesearchpopup [organizationKey]="organizationKey" [projectKey]="projectKey" [workpackageKey]="postKey" [userId]="userId" [userName]="userDisplayName" (foundUsers)="receivedFoundUsers($event)"></app-peoplesearchpopup>
        }

        @if (showTimeTracker == true && type == 'workpackage' && isReadOnly == false) {
          <app-timetrackerpopup [organizationKey]="organizationKey" [projectKey]="projectKey" [workpackageKey]="postKey" [userId]="userId" [userName]="userDisplayName" [circleColor]="color" [projectName]="projectName" [workpackageName]="name" [startDate]="startDate" [endDate]="endDate" (progressHillClosed)="onProgressHillClosed($event)"></app-timetrackerpopup>
        }


        <!-- Modal Header -->
    
    
        @if (launchedAsSubcomponent == false) {
          <div id="header" class="content-title my-3 mx-1">
            Content details (project: {{projectName}}
            @if (templateKey == 'diary') {
              <span>,
                <i class="bi bi-journal-text"></i>
                diary
              </span>
            }
            @if (templateKey == 'link') {
              <span>,
                <span class="material-symbols--link"></span>
                link
              </span>
              })
            </div>
          <div class="d-flex flex-wrap m-0 p-0" style="align-items: flex-start;">
            @if (isReadOnly == false) {
              <div class="green-tag-pill m-1 p-1" style="cursor: pointer; line-height: 1.1em;" (click)="addTag()">
                Add tag
              </div>
              <div class="green-tag-pill m-1 p-1" (click)="generateTags('', -1, true)">
                <span class="mdi--alien-outline-small me-1 p-0 my-0"></span>
                Generate tags
              </div>
            }
            @if (post && post.tags && post.tags.length > 0) {
              @for (tag of post.tags; track tag; let i = $index) {
                <div class="tag-pill m-1 p-1">
  
                    @if (editedTagIndex == i) {
                      <input type="text" class="form-control form-control-sm edit-tag-input" [(ngModel)]="editedTag" (keydown.enter)="saveEditedTag(tag)">
                      <span class="mdi--content-save mx-1 appearing-icon" (click)="saveEditedTag(tag)"></span>
                      <span class="mdi--close mx-1 appearing-icon" (click)="closeNewTagEditor()"></span>
                    } @else {
                      <span (click)="editTag(tag, i)">
                        {{tag}}
                      </span>
                    }
                  @if (editedTagIndex == -1) {
                    <span class="mdi--close appearing-icon" (click)="removeTag(tag)"></span>
                  }
                </div>
              }
            }
          </div>
          @if (site == "productly") {
            <div class="persona-container">
              Personas: 
              @for (persona of personas; track persona.key) {
                <div class="persona-pill" [ngClass]="{'persona-pill-selected': persona.isSelected}" (click)="selectPersona(persona.key)">{{persona.name}}</div>
              }
            </div>
          }
        }
        @if (isColorPalleteVisible && isReadOnly == false) {
            <color-circle [color]="color" [colors]="colors" (onChangeComplete)="changeComplete($event)"></color-circle>
        }
    
        <div class="row d-flex m-0 p-0">
          <div class="col overflow-auto m-0 ps-0 pt-0" (click)="enterEdit()" >
            @if (type == 'workpackage') {
              <span>
                Task in project: {{projectName}} 
                @if (parentName != '') {
                  <span>in {{parentName}}</span>
                }
                @if (progressPercent != undefined && progressPercent != 0) {
                  <span> - progress: {{progressPercent}}%</span>
                }
                @if (manHours != undefined && manHours != 0) {
                  <span>, man hours: {{manHours}}</span>
                }
                @if (startDate != undefined && startDate != '') {
                  <span>, start date: {{startDate}}</span>
                }
                @if (endDate != undefined && endDate != '') {
                  <span>, end date: {{endDate}}</span>
                }
            </span>
            }
            <div class="btn-group mx-2" role="group" >
              @if (assignedUsers.length > 0) {
                <small>
                  Members:
                </small>
              }
              @for (a of assignedUsers; track a.id; let i = $index) {
                <button class="btn" (click)="showUserDetails(i)">
                  @if (a.img != '') {
                    <img src="{{a.img}}" alt="{{a.name}}" class="image-placeholder">
                  }
                  @if (a.img == '') {
                    <span class="image-placeholder">
                      {{a.name.slice(0,3)}}
                    </span>
                  }
                  @if (a.show == true) {
                    <app-userdetailspopup [organizationKey]="organizationKey" [userId]="a.id" [name]="a.name" [email]="a.email" [photo]="a.img" [workpackageKey]="postKey" (foundUsers)="receivedFoundUsers($event)"></app-userdetailspopup>
                  }
                </button>
              }
            </div>
    


          <!-- list of fields -->
          @if (fields && fields.length > 0 && editors && editors.length > 0) {
            <div class="list-group list-group-flush mt-0 p-0 ms-0" style="min-height: 400px; max-width: 100%;" cdkDropList (cdkDropListDropped)="fieldDropped($event)" (mousemove)="onMouseMove($event)">
              @for (field of fields; track field.key; let i = $index) {


                <div class="p-0 m-0 position-relative" cdkDrag [cdkDragDisabled]="isReadOnly == true || editModeSelected == false" id="field{{i}}" [ngClass]="{'list-group-item': editModeSelected == true && isReadOnly == false}"  (mouseenter)="showGrabIcon(true, $event)" (mouseleave)="showGrabIcon(false)">
                  @if (isReadOnly == false && editModeSelected == true) {

                    <div id="template" class="d-flex justify-content-end p-0 m-0 position-relative" style="cursor: move; width: 15px;" cdkDragHandle>
                      <button class="ps-0 pe-3 section-handle position-relative" type="button" (click)="toggleContextMenu(i)" aria-expanded="false" [ngClass]="{'d-none': !isHovering}">
                        <div class="grab-icon" [style.top.px]="mouseY">
                          <i class="charm--grab-vertical hover-icon"></i>
                        </div>
                        @if (visibleContextMenuIndex == i) {
                          <div class="context-menu p-1">
                            @if (field.links.length > 0) {
                              <div class="context-menu-item" (click)="scrapePage(field.links[0], i)">
                                <i class="mdi--alien-outline"></i>
                                Generate link summary
                              </div>
                            }
                              <div class="context-menu-item" (click)="generateTags(field.content, i)">
                                <i class="mdi--alien-outline"></i>
                                Generate tags
                              </div>
                            @if (field.type == 'files' && lastImageURL != '') {
                              <div class="context-menu-item" (click)="getImageDescription(lastImageURL)">
                                <i class="mdi--alien-outline"></i>
                                Describe image
                              </div>
                            }
                            <div class="context-menu-item" (click)="deleteField(i)">Delete field</div>
                            <div class="context-menu-item" (click)="addField(i, 'plain')">Add plain text</div>
                            <div class="context-menu-item" (click)="addField(i, 'html','', true, true)">Add formatted text</div>
                            <div class="context-menu-item" (click)="addField(i, 'datealert')">Add date alert</div>
                            <div class="context-menu-item" (click)="addField(i, 'label')">Add section label</div>
                            <div class="context-menu-item" (click)="addField(i, 'table')">Add table</div>
                            <div class="context-menu-item" (click)="addField(i, 'quiz')">Add quiz</div>
                            <div class="context-menu-item" (click)="addField(i, 'content')">Add linked content</div>
                            <div class="context-menu-item" (click)="addField(i, 'files')">Add files</div>
                            <div class="context-menu-item" (click)="addField(i, 'checklist')">Add checklist</div>
                            <div class="context-menu-item" (click)="addField(i, 'progressbar')">Add progress bar</div>
                            <div class="context-menu-item" (click)="addField(i, 'dropdown')">Add dropdown</div>
                            <div class="context-menu-item" (click)="addField(i, 'multidropdown')">Add multiselect dropdown</div>
                            <div class="context-menu-item" (click)="addField(i, 'icescore')">Add ICE score</div>
                          @if (field.type == 'html' || field.type == 'html') {
                              <div class="context-menu-item" (click)="showAIAssistant(i)">
                                AI Assistant
                              </div>
                          }
                          </div>
                        }
                      </button>
                    </div>
                  }

                  <!-- different types of fields content -->
                  <div class="mx-1 w-100 my-0 p-0 d-flex align-items-center">
                    @if (field.type == 'label') {
                      @if (field.isExpanded == true) {
                        <span class="fluent--triangle-down-12-filled me-1 pointer" (click)="toggleLabelSection(i)"></span>
                      } @else  {
                        <span class="fluent--triangle-right-12-filled me-1 pointer" (click)="toggleLabelSection(i)"></span>
                      }
                        <span id="section" class="">
                        @if (isReadOnly == false && editModeSelected == true) {
                          <input [(ngModel)]="fields[i].content" class="form-control input-no-frame label" (input)="turnEdit(i)">
                        }
                        @if (isReadOnly == true || editModeSelected == false) {
                          <p class="label m-0 p-0">
                            {{field.content}}
                          </p>
                        }
                      </span>
                    }
                    @if (field.type == 'quiz') {
                      <div id="section" class="quiz-div ms-2">
                        @if (quizes.length > 0 && isReadOnly == false && editModeSelected == true) {
                          <div class="my-1 text-section">
                            <select id="changeorg" class="form-select-sm" [(ngModel)]="fields[i].content" (change)="selectQuiz(i)">
                              @for (q of quizes; track q.key) {
                                <option  [value]="q.key">{{q.name}}</option>
                              }
                            </select>
                          </div>
                        }
                        @if (organizationKey != '' && organizationKey != undefined) {
                          <app-quiz [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [quizKey]="fields[i].content" [quizName]="quizName" [quizDescription]="quizDescription"></app-quiz>
                        }
                      </div>
                    }
                    @if (field.type == 'table') {
                      <div id="section" class="quiz-div m-0 ms-2 p-0 text-section">
                        @if (organizationKey != '' && organizationKey != undefined) {
                          <app-table [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [tableJson]="field.content" [fieldKey]="field.key" (listenTable)="updateJsonField($event)"></app-table>
                        }
                      </div>
                    }
                    @if (field.type == 'plain') {
                      <span class="">
                        @if (!isAutofocusSet && isReadOnly == false && editModeSelected == true) {
                            <input id="editor-{{i}}" autofocus [(ngModel)]="fields[i].content" placeholder="{{fields[i].placeholder}}" class="form-control input-no-frame py-1 text-section" (load)="setAutofocus()" (keydown)="onKeyDown($event, i, 'plain')" (input)="turnEdit(i)" (keyup)="onKeyUp($event, i)">
                        }
                        @if (isAutofocusSet && isReadOnly == false && editModeSelected == true) {
                            <input [(ngModel)]="fields[i].content" placeholder="{{fields[i].placeholder}}" class="form-control input-no-frame py-1 text-section" (input)="turnEdit(i)">
                        }
                        @if (isReadOnly == true || editModeSelected == false) {
                          <p class="text-section py-1 m-0 ps-0">
                            {{field.content}}
                          </p>
                        }
                      </span>
                    }
                    @if (field.type == 'html' && field.isExpanded == true) {
                      <span class="w-100 position-relative m-0 ms-2 p-0">
                        @if (editors[i] && editors[i].showToolbar != undefined && editors[i].showToolbar == true && isReadOnly == false && editModeSelected == true) {
                          <div class="w-100 position-relative">
                            @if (i > 1) {
                              <div class="toolbar position-absolute" style="max-width: 100%;">
                                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                                <a class="btn btn-outline-dark btn-sm noborder hidetoolbaricon position-absolute m-1" (click)="hideToolbar(i)">
                                  <i class="bi bi-x"></i>
                                </a>
                              </div>
                            }
                          </div>

                          <div class="w-100 p-0 m-0 position-relative">
                            @if (editor) {
                              <ngx-editor id="editor-{{i}}" [editor]="editor" [(ngModel)]="fields[i].content" placeholder="{{field.placeholder}}" (focusIn)="focusIn(i)" (focusOut)="hideToolbar(i)" (keyup)="onKeyUp($event,i)" (input)="turnEdit(i)" (paste)="onPaste($event, i)" (ngModelChange)="onChange($event, i)" class="w-100 ngx-editor m-0 p-0" (keydown)="onKeyDown($event, i, 'html')"></ngx-editor>
                            }
                            <a class="btn btn-outline-dark btn-sm noborder addfieldtoolbaricon position-absolute m-1" (click)="commandEnterHit(currentFieldIndex)">
                              ⌘
                              <i class="bi bi-arrow-return-left"></i>
                            </a>
                          </div>
                          <div class="p-0 m-0 position-relative">
                            @if (i <= 1) {
                              <div class="toolbar-bottom position-absolute" style="max-width: 100%;">
                                <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                                <a class="btn btn-outline-dark btn-sm noborder hidetoolbaricon position-absolute m-1" (click)="hideToolbar(i)">
                                  <i class="bi bi-x"></i>
                                </a>
                          </div>
                          }
                        </div>
                        }
                        
                        @if (editors[i] && editors[i].showToolbar != undefined && editors[i].showToolbar == false && isReadOnly == false && editModeSelected == true) {
                          <div (click)="showToolbar(i, true)" class="w-100 p-0 ms-0 mt-2 me-0 max-width editor-section">
                            @if (field.content == undefined || field.content.length == 0) {
                              <span class="text-secondary m-0 p-0">
                                Click and type your content here or press / to add new field.
                              </span>
                            }
                            @if (field.content != undefined && field.content.length > 0) {
                              <div class="editor-section ms-2 p-0">
                                <p [innerHTML]="field.content | safeHtml" class="max-width m-0 p-0 text-section" ></p>
                              </div>
                            }
                          </div>
                        }
                        @if (isReadOnly == true || editModeSelected == false) {
                          <div class="editor-section m-0 p-0">
                            <p [innerHTML]="field.content | safeHtml" class="max-width m-0 p-0 text-section" ></p>
                          </div>
                        }
                      </span>
                    }
                    @if (field.type == 'files' && field.isExpanded == true) {
                      <span class="w-100 position-relative m-0 ms-2 p-0">
                        @if (isReadOnly == false && editModeSelected == true) {
                          <app-uploadfile [organizationKey]="organizationKey" [projectKey]="projectKey" [contentKey]="postKey" [userId]="userId" [contentType]="'post'" [newContent]="isNewPost" [imageOnly]="false" (isFileUploaded)="isFileUploaded($event)" [projectName]="projectName" [captureImageImmediately]="captureImage" (sendCoverImageUpdate)="updateCoverImage($event)" (orderGenerateDescription)="getImageDescription($event)" [embbeddingModel]="embeddingModel" (addHTMLField)="onAddHTMLField($event)"></app-uploadfile>
                        }
                        @if (postKey != '') {
                          <app-attachedfiles [organizationKey]="organizationKey" [projectKey]="projectKey" [contentKey]="postKey" [canDelete]="(isReadOnly == false && editModeSelected == true)" (sendImageUrl)="recievedImageUrl($event)" (addHTMLField)="onAddHTMLField($event)" (isLoading)="onIsLoading($event)" (addTableField)="onAddTableField($event)" (addLabelField)="onAddLabelField($event)"></app-attachedfiles>
                        }
                      </span>
                    }
                    @if (field.type == 'note') {
                      <span class="w-100 position-relative m-0 ms-2 p-0">
                        @if (linkedPosts.length > 0) {
                          <span>
                            <p class="section-header">
                              Similar notes
                            </p>
                            @if (isAddPostClicked && isReadOnly == false && editModeSelected == true) {
                              <input [(ngModel)]="addedPostLink" placeholder="Wklej link do notatki" class="form-control input-no-frame">
                            }
                            @if (isReadOnly == false && editModeSelected == true) {
                              <button type="button" class="btn btn-outline-secondary" (click)="addLinkedPost()" matTooltip="Link note" matTooltipShowDelay="2000">
                                <i class="bi bi-file-plus"></i>
                              </button>
                            }
                            <app-linkednotes [organizationKey]="organizationKey" [projectKey]="projectKey" [posts]="linkedPosts" [templates]="templates" [postKey]="postKey" [fieldKey]="fieldKeyWithLinks.toString()"></app-linkednotes>
                          </span>
                        }
                        @if (linkedPosts.length == 0) {
                          <span>
                            <p class="section-header ms-2">
                              No similar notes found
                            </p>
                            @if (isAddPostClicked && isReadOnly == false && editModeSelected == true) {
                              <input [(ngModel)]="addedPostLink" placeholder="Wklej link do notatki" class="form-control input-no-frame">
                            }
                            @if (isReadOnly == false && editModeSelected == true) {
                              <button type="button" class="btn btn-outline-secondary" (click)="addLinkedPost()" matTooltip="Powiąż notatkę">
                                <i class="bi bi-file-plus"></i>
                              </button>
                            }
                          </span>
                        }
                      </span>
                    }
                    @if (field.type == 'content') {
                      <div id="section" class="quiz-div ms-2">
                        @if (organizationKey != '' && organizationKey != undefined) {
                          <app-linkedcontent [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [tableJson]="field.content" [fieldKey]="field.key" [contentKey]="postKey" [embeddingModel]="embeddingModel" (listenTable)="updateJsonField($event)"></app-linkedcontent>
                        }
                      </div>
                    }
                    @if (field.type == 'datealert') {
                      <div class="w-100 position-relative m-0 ms-2 p-0">
                        <div class="row" [ngClass]="getAlertClass(field.date)" >
                          <div class="col-lg-4 col-sm-12 mt-1">
                            <div class="m-0 p-0 d-flex align-items-center">
                              Date alert:
                              <input id="startDate" class="form-control m-0 p-0 datepicker" type="date" [(ngModel)]="fields[i].date" (change)="updatePickedDate(i)" class="mx-2"/>
                              @if (getDateDifference(fields[i].date) >= 0) {
                                <span>
                                  {{getDateDifference(fields[i].date)}} days left
                                </span>
                              }
                              <a class="btn btn-outline-dark btn-sm m-1" (click)="signInForEmail()">
                                <i class="bi bi-envelope"></i> Email alert
                              </a>
                            </div>
                          </div>
                          <div class="col-lg-8 col-sm-12 mt-1">
                            @if (editors[i] && editors[i].showToolbar != undefined && editors[i].showToolbar == true && isReadOnly == false && editModeSelected == true) {
                              <div class="w-100 p-0 m-0 editor position-relative">
                                @if (i > 1) {
                                  <div class="toolbar position-absolute">
                                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                                    <a class="btn btn-outline-dark btn-sm noborder hidetoolbaricon position-absolute m-1" (click)="hideToolbar(i)">
                                      <i class="bi bi-x"></i>
                                    </a>
                                  </div>
                                }
                              </div>
                              <div class="w-100 p-0 m-0 editor position-relative">
                                @if (editor) {
                                  <ngx-editor id="editor-{{i}}" [editor]="editor" [(ngModel)]="fields[i].content" placeholder="{{fields[i].placeholder}}" (focusIn)="focusIn(i)" (focusOut)="hideToolbar(i)" (keyup)="onKeyUp($event, i)" (input)="turnEdit(i)" (paste)="onPaste($event, i)" (ngModelChange)="onChange($event, i)" class="p-0 m-0" (keydown)="onKeyDown($event, i, 'html')"></ngx-editor>
                                }
                                <a class="btn btn-outline-dark btn-sm noborder addfieldtoolbaricon position-absolute m-1" (click)="commandEnterHit(currentFieldIndex)">
                                  ⌘
                                  <i class="bi bi-arrow-return-left"></i>
                                </a>
                              </div>
                              <div class="p-0 m-0 editor position-relative">
                                @if (i <= 1) {
                                  <div class="toolbar-bottom position-absolute">
                                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                                    <a class="btn btn-outline-dark btn-sm noborder hidetoolbaricon position-absolute m-1" (click)="hideToolbar(i)">
                                      <i class="bi bi-x"></i>
                                    </a>
                                  </div>
                                }
                              </div>
                            }
                            @if (editors[i] && editors[i].showToolbar != undefined && editors[i].showToolbar == false && isReadOnly == false && editModeSelected == true) {
                              <div (click)="showToolbar(i, true)" class="w-100 p-0 m-0 max-width">
                                @if (field.content == undefined || field.content.length == 0) {
                                  <span class="text-secondary m-0 p-0">
                                    Click and type name of date alert here.
                                  </span>
                                }
                                @if (field.content != undefined && field.content.length > 0) {
                                  <span [innerHTML]="field.content | safeHtml"  class="max-width m-0 p-0">
                                  </span>
                                }
                              </div>
                            }
                            @if (isReadOnly == true || editModeSelected == false) {
                              <div>
                                <p [innerHTML]="field.content | safeHtml" class="max-width m-0 p-0"></p>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    @if (field.type == 'checklist') {
                      <div class="ms-2">
                        <app-checklist [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [tableJson]="field.content" [fieldKey]="field.key" [contentKey]="postKey" [aggregatedContent]="aggregatedContent" (listenTable)="updateJsonFieldChecklist($event)"></app-checklist>
                      </div>
                    }
                    @if (field.type == 'progressbar') {
                      <div class="ms-2">
                        <app-progressbar [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [content]="field.content" [fieldKey]="field.key" [contentKey]="postKey" [aggregatedContent]="aggregatedContent" (valueChange)="updateJsonFieldDropdown($event)"></app-progressbar>
                      </div>
                    }
                    @if (field.type == 'dropdown' || field.type == 'multidropdown') {
                      <div class="ms-2">
                        <app-dropdown [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [content]="field.content" [fieldKey]="field.key" [contentKey]="postKey" [aggregatedContent]="aggregatedContent" (valueChange)="updateJsonFieldDropdown($event)"></app-dropdown>
                      </div>
                    }
                    @if (field.type == 'icescore') {
                      <div class="ms-2">
                        <app-icescore [organizationKey]="organizationKey" [projectKey]="projectKey" [userId]="userId" [content]="field.content" [fieldKey]="field.key" [contentKey]="postKey" [aggregatedContent]="aggregatedContent" (valueChange)="updateJsonFieldDropdown($event)"></app-icescore>
                      </div>
                    }
                  </div>

                </div>

              }
              @if (isReadOnly == false && editModeSelected == true) {
                <div  (click)="addField(fields.length-1, 'html', '', false, true)" class="my-1">
                    <span class="green-button">
                    <span class="mdi--add green-icon"></span>
                  </span>
                  <span class="new-section-label ms-2">
                    Start typing here.
                  </span>
                </div>
              }
            </div>

          }

          </div>
            



          @if (isReadOnly === false && editModeSelected === true) {
          <div class="small-text">
            Press shift+⌘/ctrl+V to paste content into mulitple sections. Press ⌘/ctrl+<i class="bi bi-arrow-return-left"></i> to add new section, ctrl+A to add date alert, ctrl+D to delete section. Type / to add new field.
          </div>
          }
        </div>
        

      
        @if (post.contentType === 'canvas') {
          <div>
            <a href="https://wroolo.com/canvas/{{organizationKey}}/{{projectKey}}/{{postKey}}" class="canvas-link">
              <i class="bi bi-pencil"></i>
              Browse to canvas
            </a>
            <a href="https://wroolo.com/canvas/{{organizationKey}}/{{projectKey}}/{{postKey}}" class="canvas-link">
              <img src="{{post.coverImageURL}}" class="cover-image" />
            </a>
          </div>
        }
        @if (type == 'post' && bookMode == false) {
          <app-similarcontent [userId]="userId" [organizationKey]="organizationKey" [projectKey]="projectKey" [projectName]="projectName" [contentKey]="postKey" [embedding]="postEmbedding" [isReadOnly]="isReadOnly || editModeSelected == false" [embeddingModel]="embeddingModel"></app-similarcontent>
        }
      </div>

      <!-- chat panel-->
      @if (isChatVisible === true) {
        <div class="col-4 overflow-auto bg-light">
          @if (postKey !== '') {
            <div>
              @if (postKey !== ''&& postKey !== undefined) {
                <app-discussionchannellazy [organizationKey]="organizationKey" [projectKey]="projectKey" [channelKey]="channelKey" [userId]="userId" [userDisplayName]="userDisplayName" [contentType]="'workpackage'" [projectName]="projectName" [embeddingModel]="embeddingModel"></app-discussionchannellazy>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- context menu displayed when slash is detected-->

      <div id="context-menu-slash" class="context-menu-slash p-1" [ngStyle]="{'display': isSlashDetected == true && focusedFieldIndex > -1 ? 'block' : 'none'}" >
        @if (focusedFieldIndex > -1) {
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'plain')" >Add plain text</div>
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'html','', true, true)">Add formatted text</div>
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'datealert')">Add date alert</div>
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'label')">Add section label</div>
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'table')">Add table</div>
        <!--div class="context-menu-item" (click)="addField(focusedFieldIndex, 'quiz')">Add quiz</div-->
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'content')">Add linked content</div>
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'files')">Add files</div>
        <div class="context-menu-item" (click)="addField(focusedFieldIndex, 'checklist')">Add checklist</div>
        @if (fields[focusedFieldIndex].type == 'html' || fields[focusedFieldIndex].type == 'html') {
            <div class="context-menu-item" (click)="showAIAssistant(focusedFieldIndex)">
              AI Assistant
            </div>
        }
        <div class="context-menu-item" (click)="deleteField(focusedFieldIndex)">Delete field</div>
        @if (fields[focusedFieldIndex].links.length > 0) {
          <div class="context-menu-item" (click)="scrapePage(fields[focusedFieldIndex].links[0], focusedFieldIndex)">
            <i class="mdi--alien-outline"></i>
            Generate link summary
          </div>
        }
        @if (fields[focusedFieldIndex].type == 'files' && lastImageURL != '') {
          <div class="context-menu-item" (click)="getImageDescription(lastImageURL)">
            <i class="mdi--alien-outline"></i>
            Describe image
          </div>
        }
        <div class="context-menu-item" (click)="generateTags(fields[focusedFieldIndex].content, focusedFieldIndex)">
          <i class="mdi--alien-outline"></i>
          Generate tags
        </div>
      }
      </div>
    
  </div>


